 import Vue from 'vue'
const getAvailability = async function (query) {

    query = {
        fromDate: query.from.toISOString(),
        toDate: query.to.toISOString(),
        unit: query.unit,
        workflowId: query.workflowId,
        useShiftsPerWorkflowTable: true
    }

    let availablity = await Vue.prototype.$FUNCTIONS.OeeAnalytics("getAvailability", query).catch(e => {
    })
    return availablity

}
 const getQuality = async function (query) {

     query = {
         fromDate: query.from.toISOString(),
         toDate: query.to.toISOString(),
         unit: query.unit,
         workflowId: query.workflowId,
         useShiftsPerWorkflowTable: true

     }
     let quality = await Vue.prototype.$FUNCTIONS.OeeAnalytics("getQuality", query).catch(e => {
     })
     return quality

 }
const getPerformance = async function (query) {

    query = {
        fromDate: query.from.toISOString(),
        toDate: query.to.toISOString(),
        workflowId: query.workflowId,
        unit: query.unit,
        productNumberKey: query.productNumberKey,
        npcKey: query.npcKey,
        useShiftsPerWorkflowTable: true

    }
    let performance = await Vue.prototype.$FUNCTIONS.OeeAnalytics("getPerformance", query).catch(e => {
        console.error(e);
    })
    return performance

}
export {
    getAvailability,
    getPerformance,
    getQuality
}